import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <span className="footer-logo-text">FM</span>
              </div>
              <span className="footer-logo-name">FINDMEAGENT</span>
            </div>
            <p className="footer-tagline">
              Connecting you with trusted local real estate agents for your property journey.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              {[
                ['/how-it-works', 'How It Works'],
                ['/why-us', 'Why Choose Us'],
                ['/sell-your-property', 'Sell Your Property'],
                ['/free-property-appraisal', 'Free Property Appraisal'],
                ['/compare-agents', 'Compare Agents'],
                ['/real-estate-agent-fees-australia', 'Agent Fees Guide'],
                ['/faq', 'FAQ'],
                ['/join-as-agent', 'Agents: Join Us'],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="footer-link" data-testid={`footer-link-${to.slice(1)}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Mail size={18} />
                <span>info@findmeagent.com.au</span>
              </li>
              <li className="footer-contact-item">
                <Phone size={18} />
                <span>Available via form</span>
              </li>
              <li className="footer-contact-item">
                <MapPin size={18} />
                <span>Australia Wide</span>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Get Started</h4>
            <p className="footer-cta-text">
              Ready to find your perfect real estate agent?
            </p>
            <button 
              onClick={() => scrollToSection('contact')}
              className="footer-cta-btn"
            >
              Find My Agent
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} FindMeAgent. All rights reserved.
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy" className="footer-legal-link" data-testid="footer-privacy-link">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
